module.exports = __webpack_public_path__ + "img/3.41764a42.webp";